import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  Typography,
} from "@material-tailwind/react";
import dayjs from 'dayjs';
import 'moment/locale/th'

import React, { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { SettingContext } from "../App";
import weekOfYear from 'dayjs/plugin/weekOfYear'
import advancedFormat from "dayjs/plugin/advancedFormat"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)

export default function TimeRangeIgnoreYearSetting() {

    const { state, setting, setSetting } = React.useContext(SettingContext);

    const [activeTab, setActiveTab] = useState(state.setting.case_count.comparison.time_range.selected);

    const [startWeek, setStartWeek] = useState(state.setting.case_count.comparison.time_range.W.start);
    const [endWeek, setEndWeek] = useState(state.setting.case_count.comparison.time_range.W.end);

    const [startMonth, setStartMonth] = useState(dayjs().month(state.setting.case_count.comparison.time_range.M.start-1));
    const [endMonth, setEndMonth] = useState(dayjs().month(state.setting.case_count.comparison.time_range.M.end-1));

    const data = [
        {
            label: "สัปดาห์",
            value: "W",
        },
        {
            label: "เดือน",
            value: "M",
        },
    ];

    const weeks = Array.from({ length: 53 }, (value, index) => index);

    const handleTabChange = (value) => {
        if(value !== setting.case_count.comparison.time_range.selected){
            setActiveTab(value)
            let _setting = {...setting}
            _setting.case_count.comparison.time_range.selected = value
            setSetting(_setting)
        }
    }

    const handleStartWeekSelected = (event) => {
        setStartWeek(event.target.value) 
        if(setting.case_count.comparison.time_range.W.start !== event.target.value){
            let _setting = {...setting}
            _setting.case_count.comparison.time_range.W.start = event.target.value
            setSetting(_setting)
        }
    }

    const handleEndWeekSelected = (event) => {
        setEndWeek(event.target.value) 
        if(setting.case_count.comparison.time_range.W.end !== event.target.value){
            let _setting = {...setting}
            _setting.case_count.comparison.time_range.W.end = event.target.value
            setSetting(_setting)
        }
    }

    const handleStartMonthSelected = (newValue) => {
        setStartMonth(newValue) 
        if(setting.case_count.comparison.time_range.M.start !== newValue.format('MM')){
            let _setting = {...setting}
            _setting.case_count.comparison.time_range.M.start = newValue.format('MM')
            setSetting(_setting)
        }
    }

    const handleEndMonthSelected = (newValue) => {
        setEndMonth(newValue) 
        if(setting.case_count.comparison.time_range.M.end !== newValue.format('MM')){
            let _setting = {...setting}
            _setting.case_count.comparison.time_range.M.end = newValue.format('MM')
            setSetting(_setting)
        }
    }

    return (
        <div>
            <Typography className="font-primary mb-2 mt-4 font-bold">ช่วงเวลาการแสดงผล</Typography>
            <Tabs id="time-range-ignore-year-animation" value={activeTab}>
                <TabsHeader
                    className="rounded-[4px] bg-red-50 border-red-200 border"
                    indicatorProps={{
                    className: "bg-red-900 shadow-none !text-gray-900",
                    }}
                >
                    {data.map(({ label, value }) => (
                    <Tab id="time-range-ignore-year-tab"
                        onClick={() => handleTabChange(value)}
                        className="font-primary"
                        activeClassName="text-white font-primary"
                        key={value}
                        value={value}
                    >
                        {label}
                    </Tab>
                    ))}
                </TabsHeader>
                <TabsBody
                    animate={{
                    initial: { y: 60 },
                    mount: { y: 0 },
                    unmount: { y: 60 },
                    }}
                >
                    <TabPanel key="W" value="W" className="px-0">
                        <div className="grid w-full grid-cols-2 gap-2">
                            <FormControl size="small">
                                <InputLabel id="demo-select-small-label">สัปดาห์เริ่มต้น</InputLabel>
                                <Select
                                    labelId="demo-select-small-label"
                                    id="start-week-select"
                                    label="สัปดาห์เริ่มต้น"
                                    value={startWeek}
                                    onChange={handleStartWeekSelected}
                                >   
                                    {weeks.map((week) => (
                                        <MenuItem key={week+1} value={week+1} disabled={(week+1) > endWeek}>{week+1}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small">
                                <InputLabel id="demo-select-small-label">สัปดาห์สิ้นสุด</InputLabel>
                                <Select
                                    labelId="demo-select-small-label"
                                    id="end-week-select"
                                    label="สัปดาห์สิ้นสุด"
                                    value={endWeek}
                                    onChange={handleEndWeekSelected}
                                >   
                                    {weeks.map((week) => (
                                        <MenuItem key={week+1} value={week+1} disabled={(week+1) < startWeek}>{week+1}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </TabPanel>
                    <TabPanel key="M" value="M" className="px-0">
                        <div className="grid w-full grid-cols-2 gap-2">
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th" dateFormats={{ monthAndYear: 'MMMM' }} >
                                <DatePicker 
                                    slotProps={{ 
                                        textField: { size: 'small', InputLabelProps:{className:"font-primary"}, inputProps:{value: `${startMonth.format('MMMM')}`}}
                                    }} 
                                    format="MM" 
                                    label={'เดือนเริ่มต้น'} 
                                    views={["month"]}      
                                    onChange={handleStartMonthSelected}
                                    value={startMonth}
                                    maxDate={endMonth}
                                    minDate={dayjs().month(0)}
                                /> 
                                <DatePicker 
                                    slotProps={{ 
                                        textField: { size: 'small', InputLabelProps:{className:"font-primary"}, inputProps:{value: `${endMonth.format('MMMM')}`} },
                                    }}  
                                    format="MM" 
                                    label={'เดือนสิ้นสุด'} 
                                    views={["month"]}
                                    onChange={handleEndMonthSelected}
                                    value={endMonth}
                                    minDate={startMonth}
                                    maxDate={dayjs().month(11)}
                                /> 
                            </LocalizationProvider>
                        </div>
                    </TabPanel>
                </TabsBody>
            </Tabs>
        </div>
        
    );
}
